module.exports = __webpack_public_path__ + "static/img/select_delete.59806394.svg";